import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
const Navigation = (props) => {
  const style = { paddingRight: "2%" };
  return (
    <Navbar bg="light" data-bs-theme="light">
      <img
        src="images/TTD_Lockup_BlackInk.png"
        height="15"
        alt="Logo1"
        style={style}
      />
      <Container>
        <Nav className="me-auto">
          <Nav.Link href="/campaign_list">Campaign List</Nav.Link>
          <Nav.Link href="/on_board_campaign">Onboard Campaign</Nav.Link>
          <Nav.Link href="/campaign_qa_results">QA Campaign</Nav.Link>
          <Nav.Link href="/Users">User Management</Nav.Link>
        </Nav>
        <Nav className="ms-auto">
          <Nav.Link>Welcome {props.User.email}</Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default Navigation;
